import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, onMounted, onUnmounted } from 'vue'

  import LoadingSpinner from '@/components/common/LoadingSpinner.vue'
  import SVGRenderer from '@/components/common/SVGRenderer.vue'

  import useIcons from '@/composables/useIcons'
  import useCourse from '@/composables/useCourse'
  import useCommonMixin from '@/composables/useCommonMixin'
  import useShopifyClient from '@/composables/useShopifyClient'

  import { UserModule } from '@/store/modules/user'

  import * as Sentry from '@sentry/vue'

  declare global {
    interface Window {
      createShopifyCheckout?: () => void
    }
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'DashboardFAQs',
  props: {
    type: null
  },
  setup(__props: any) {

const props = __props as { type: 'default' | 'purchased' };

  

  const { arrowDown } = useIcons()
  const { course, courseBundle } = useCourse()
  const { extractCourseVertical } = useCommonMixin()
  const { createShopifyCheckout } = useShopifyClient()

  const loading = ref(true)
  const showAll = ref(false)
  const activeFaq = ref<number>(0)

  const academyName = computed(() => {
    return UserModule.currentCompany?.name || 'Sachkundegurus'
  })

  const faqs = computed(() => UserModule.faqs)

  const visibleFaqs = computed(() => {
    if (showAll.value) {
      return filteredFaqs.value
    }
    return filteredFaqs.value.slice(0, 3)
  })

  const formattedFaqAnswer = computed(() => (answer: string) => {
    return answer.replace(
      'Kurs auswählen',
      `<span class="ketch-font-bold ketch-cursor-pointer hover:ketch-underline" onclick="window.createShopifyCheckout()">Kurs auswählen</span>`,
    )
  })

  // Expose createShopifyCheckout to window for onclick handler
  onMounted(() => {
    window.createShopifyCheckout = createShopifyCheckout
  })

  onUnmounted(() => {
    delete window.createShopifyCheckout
  })

  const filteredFaqs = computed(() => {
    let filtered = faqs.value

    if (courseBundle.value) {
      const courseVertical = extractCourseVertical(courseBundle.value?.title || '') || 'General'
      filtered = filtered.filter((faq) => faq.courseVertical === 'General' || faq.courseVertical === courseVertical)
    }

    if (props.type === 'default' && (course?.value?.trial || course?.value?.expired)) {
      filtered = filtered.filter((faq) => faq.visibleInTrialMode)
    }

    return filtered
  })

  const toggleFaq = (position: number) => {
    if (activeFaq.value == position) {
      activeFaq.value = 0
    } else {
      activeFaq.value = position
    }
  }

  const toggleShowAll = () => {
    showAll.value = !showAll.value
  }

  onMounted(async () => {
    try {
      await UserModule.getFaqs(props.type)
    } catch (err) {
      Sentry.captureException(err)
    } finally {
      loading.value = false
    }
  })

return { __sfc: true,props, arrowDown, course, courseBundle, extractCourseVertical, createShopifyCheckout, loading, showAll, activeFaq, academyName, faqs, visibleFaqs, formattedFaqAnswer, filteredFaqs, toggleFaq, toggleShowAll, ref, computed, onMounted, onUnmounted, LoadingSpinner, SVGRenderer, useIcons, useCourse, useCommonMixin, useShopifyClient, UserModule, Sentry }
}

})